<template>
  <div>
    <table-layout
      pkField="merger_id"
      :selected.sync="selected"
      :isAdmin="isAdmin"
      :loading="serversLoading"
      :items="mergers"
      :columns="columns"
      :addOptions="mergeTypes"
      @click:addNew="addMerge"
    >
      <template #actions>
        <b-dropdown-item @click="openDialogRemove" aria-role="listitem">{{ $t('lists.deleteDetail') }}</b-dropdown-item>
      </template>
    </table-layout>
  </div>
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import TableLayout from '@/layout/TableLayout'
const { mapState: mapUserState } = createNamespacedHelpers('general')

export default {
  name: 'Mergers',
  components: {
    TableLayout
  },
  data() {
    return {
      mergers: [],
      serversLoading: false,
      mergeTypes: [],
      selected: [],
      columns: [
        {
          sortable: true,
          field: 'name',
          label: 'columns.name',
          route: {
            name: 'merge',
            params: [
              {
                name: 'merger_id',
                field: 'merger_id'
              }
            ]
          }
        },
        {
          field: 'status',
          label: 'columns.status'
        },
        {
          sortable: true,
          field: 'created_time',
          label: 'columns.created_time'
        },
        {
          sortable: true,
          field: 'modified_time',
          label: 'columns.modified_time'
        }
      ]
    }
  },
  computed: {
    ...mapUserState({
      role: state => state.user.role
    }),
    isAdmin() {
      return this.role === 'ADMIN'
    }
  },
  created() {
    this.refetch()
  },
  methods: {
    ...mapActions('general', ['setServerName']),

    addMerge(type) {
      this.$router.push({
        name: 'add_merge',
        params: {
          server_id: this.$route.params.server_id
        },
        query: { type }
      })
    },

    async refetch() {
      if (this.serversLoading) return

      const body = {
        server_id: this.$route.params.server_id
      }
      const searchParams = new URLSearchParams(body)
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/mergers?${searchParams}`

      this.serversLoading = true
      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include'
        })

        if (!response.ok) {
          throw await response.json()
        }

        const data = await response.json()
        this.mergers = data.mergers
        this.mergeTypes = data.mergeTypes
        this.setServerName(data.server_name)
      } catch (error) {
        this.$notify({
          message: JSON.parse(error.message).message,
          type: 'danger'
        })
      } finally {
        this.serversLoading = false
      }
    },

    async deleteMergers(merger_ids) {
      const url = `${process.env.VUE_APP_API_ENDPOINT || window.location.origin}/api/merger/delete`
      try {
        const response = await fetch(url, {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            server_id: this.$route.params.server_id,
            merger_ids
          })
        })

        if (!response.ok) {
          throw await response.json()
        }

        await response.json()
        const indexSet = new Set(merger_ids)
        this.mergers = this.mergers.filter(value => !indexSet.has(value.merger_id))
        this.selected = []
      } catch (error) {
        this.$notify({
          message: JSON.parse(error.message).message,
          type: 'danger'
        })
      }
    },

    openDialogRemove() {
      if (!this.selected.length) {
        this.$notify({
          message: this.$t('notification.unselected'),
          type: 'danger'
        })
        return
      }

      const indexSet = new Set(this.selected)
      const mergers = this.mergers.filter(value => indexSet.has(value.merger_id)).map(d => d.name)
      const msg = mergers.join(', ')

      this.$dialog.confirm({
        message: `${this.$t('confirm.remove', { msg })}?`,
        onConfirm: async () => {
          this.serversLoading = true
          try {
            await this.deleteMergers(this.selected)
            this.$notify({
              message: this.$t('notification.removed', { msg }),
              type: 'success'
            })
          } finally {
            this.serversLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.table {
  width: 100%;
}
</style>
